import { Box, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { applyRoundAndFormat } from '../../utils';

interface ComponentProps {
  value: number;
  currencyCode?: string;
}

const isDecimal = (num: number) => {
  return num % 1 !== 0;
};

const RoundAndFormatValue: React.FC<ComponentProps> = ({ value, currencyCode }) => {
  const isNumberDecimal = isDecimal(value);
  const formattedValue = applyRoundAndFormat(value, currencyCode);
  const totalValue = applyRoundAndFormat(value, currencyCode, 5);

  return (
    <Tooltip title={isNumberDecimal ? totalValue : formattedValue}>
      <Box sx={{ display: 'inline-block' }}>
        <Typography variant='textXS' >
          {formattedValue}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default RoundAndFormatValue;